import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container"];

  connect() {
    this.validateDuplicates();
  }

  validateDuplicates() {
    // Get all key inputs
    const keyInputs = this.containerTarget.querySelectorAll(
      'input[name*="[key]"]',
    );
    const keys = {};
    const duplicates = new Set();

    // Clear previous error states
    keyInputs.forEach((input) => {
      input.classList.remove("error");
      const errorMessage = input.parentElement.querySelector(
        ".duplicate-key-error",
      );
      if (errorMessage) {
        errorMessage.remove();
      }
    });

    // Check for duplicates
    keyInputs.forEach((input) => {
      const key = input.value.trim().toLowerCase();
      if (key === "") return;

      if (keys[key]) {
        duplicates.add(key);
        input.classList.add("error");
        keys[key].classList.add("error");
      } else {
        keys[key] = input;
      }
    });

    // Show error messages for duplicates
    if (duplicates.size > 0) {
      keyInputs.forEach((input) => {
        const key = input.value.trim().toLowerCase();
        if (
          duplicates.has(key) &&
          !input.parentElement.querySelector(".duplicate-key-error")
        ) {
          const error = document.createElement("p");
          error.className = "duplicate-key-error text-sm text-danger";
          error.textContent = "Duplicate key";
          input.parentElement.appendChild(error);
        }
      });
    }
  }

  // Debounced validation on input
  handleInput(event) {
    clearTimeout(this.validationTimeout);
    this.validationTimeout = setTimeout(() => {
      this.validateDuplicates();
    }, 300);
  }
}
